import styled from "styled-components";

export default styled.div`
  padding: 10px 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 202px;
  height: 100%;
  border-right: 2px solid #f2f4f6;
`;
